export default "__VITE_ASSET__DgNot0m$__"